import { hasEntitlement, type Entitlements } from '../core/billing/entitlements';
import type { BillingFeature } from '../core/billing/plans';
import { useSubscription } from '../contexts/SubscriptionContext';

export interface EntitlementsApi {
  entitlements: Entitlements;
  /** Feature check; stays permissive while billing is unresolved. */
  can: (feature: BillingFeature) => boolean;
  /**
   * Granted features, or null while billing is unresolved so tab composition
   * shows everything instead of flashing a paywall on a slow network.
   */
  tabFeatures: readonly BillingFeature[] | null;
  readOnly: boolean;
  loading: boolean;
}

export function useEntitlements(): EntitlementsApi {
  const { entitlements, loading, unresolved } = useSubscription();
  return {
    entitlements,
    can: (feature) => (unresolved ? true : hasEntitlement(entitlements, feature)),
    tabFeatures: unresolved ? null : entitlements.features,
    readOnly: !unresolved && entitlements.readOnly,
    loading,
  };
}
